import Vue from "vue";
import $echarts from "echarts";
import _store from "store2";
import moment from "moment";
import App from "./App.vue";
import "./common/element.js";
import VueBus from "@/util/bus"
import router from "@/common/router/index";
import createStore from "./store/index";
import { checkNeedGoV2, goV2Login } from "@/util/index";
import axios from "@/util/axios";
import JsonExcel from "vue-json-excel";
import { checkVersion } from "@/util/version";
import { waterMark, removeWaterMark } from "@/util/waterMark";
import * as filters from "./util/filters";
import Contextmenu from "vue-contextmenujs";
Vue.use(VueBus)
Vue.use(Contextmenu);
// https://okee.oceanengine.com/vue#/
import { DatePicker } from "@okee-uikit/vue";
Vue.use(DatePicker);
// Vue.use(Cascader);
import elCascaderMulti from "el-cascader-multi";
Vue.use(elCascaderMulti);

import dataPicker from "@/component/date-picker/dataPicker";
Vue.component("dataPicker", dataPicker);

// 全局注册无权限页面，主要是使用在v1跳转v2模块上
import NotAuthPage from '@/component/not-auth-page/index.vue'
Vue.component("NotAuthPage", NotAuthPage);

Vue.component("downloadExcel", JsonExcel);

import "@/style/index.less";


const store = createStore();

Vue.config.productionTip = false;

import currency from "currency.js";

// 这里使用的是第三方的金额计算库 详情参考：官方文档 https://currency.js.org/
// number 数字金额 ； unit 单位  ； 精确度precision  ；
Vue.prototype.currency = (number = "0", unit = "", precision = 2) => {
  return currency(number, {
    symbol: unit,
    precision,
  }).format();
};

Vue.prototype.logDeveloper = (obj) => {
  console.log(
    `
    +--------+---------+
    | 前/后  |  开发者  |
    +--------+----------+
    | 前端   | ${obj.web}   |
    | 后端   | ${obj.back}     |
    +--------+----------+`
  );
};

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
moment.locale("zh-cn");
Vue.prototype.$echarts = $echarts;
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

router.onReady((to, from) => {
  // 屏蔽掉登录页进入添加重复路由的情况
  if (to.name === "@in") {
    return;
  }

  if (localStorage.getItem("loginToken")) {
    store.dispatch("GET_AUTH_MENU", {
      appId: to.query.appId,
    });

    // 获取通用字典
    store.dispatch("getDictData");
  }
});


router.beforeEach(async (to, from, next) => {
  // 1.访问v1登录页面直接进入v2登录页
  if (to.name === 'login') {
    return goV2Login();
  }

  // 2.判断是否从v2进入,可能是iframe嵌套页面，也可能是v2入口点击进入
  if (to.query.token) {
    // 设置用户信息
    localStorage.setItem('loginToken', to.query.token);
    const user = {
      id: to.query.userId,
      login_token: to.query.token,
      realname: to.query.name || '',
      name: to.query.name || '',
      redirect_to_zt: to.query.redirect_to_zt || 0
    }
    _store.set('user', user);
    store.dispatch("UPDATE_USER_ACTION", user);
    store.dispatch("UPDATE_V2USER_ACTION", {
      ...user,
      username: to.query.name || '',
      token: to.query.token,
      redirect_to_zt: to.query.redirect_to_zt || 0
    })
  }

  // 3.如果是v1正常访问链接才判断要不要跳转，如果是v2嵌套的页面不执行此逻辑
  if (to.query.source != 'v2') {
    const isCanNext = await checkNeedGoV2(to);
    if (!isCanNext) {
      return
    }
  }

  // 4.获取用户信息，如果有v1的登录信息执行到这一步说明能在v1访问
  const story_user = _store.get("user");
  if (story_user && !!Object.keys(story_user).length) {
    const { realname = "", phone = "" } = story_user;

    if (from.name != "login") {
      checkVersion();
    }

    if (to.query.source != 'v2') {
      waterMark(realname + phone.substring(phone.length - 4));
    }


    if (from.query.appId) {
      //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
      if (!to.query.appId) {
        //准备一个跳转的query对象
        let { query, meta } = to;
        query.appId = from.query.appId || "";

        if (query.appId && !meta.OffAppId) {
          next({
            path: to.path,
            query: query,
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    removeWaterMark();
    // if (to.name === "login") {
    //   return goV2Login();
    // } else {
    //   next("/login");
    // }
    // 5.如果t用户信息不存在，可能是点击收藏链接，走具体的页面判断逻辑，看跳转登录页还是具体的页面
    return goV2Login(to);
  }

  if (process.env.NODE_ENV == "production") {
    if (to.path) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }

  next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
